
import React, { useCallback, useState } from 'react';
import { Form, Input } from 'antd';
import SelectInput from 'src/components/shared/selectInput';
import { validateContentRules } from 'src/utils/custom.validator';
const { TextArea } = Input;
const Details = ({ caseDetails, caseStateLu, form, updateCaseDetails }) => {
    const [selectedState, setSelectedState] = useState('')
    const handleChange = useCallback((value) => {
        setSelectedState(value)
        updateCaseDetails(value);
        form.setFieldsValue({ state: value });
    }, [form, updateCaseDetails])
    return (
        <div className='border border-StrokeColor rounded-5 p-4'>
            <div className='grid xl:grid-cols-3 md:grid-cols-2 gap-4 cases-user-input'>
                <div className=''>
                    <p className='summary-label'>Case Number</p>
                    <p className='summary-value'>{caseDetails?.caseNumber || ''}</p>
                </div>
                <div className=''>
                    <p className='summary-label'>Case Title</p>
                    <p className='summary-value'>{caseDetails?.caseTitle || ''}</p>
                </div>
                <div className=''>
                    <p className='summary-label'>Module</p>
                    <p className='summary-value'>{caseDetails?.appName || ''}</p>
                </div>
                {(selectedState === "Reopened" || caseDetails?.state === "Reopened") && (
                    <div className="custom-user-input">
                        <Form.Item
                            name="reason"
                            className="custom-input mb-0"
                            label="Customer Remarks"
                            rules={[
                                {

                                    whitespace: true
                                },
                                {
                                    validator: validateContentRules
                                }
                            ]}
                        >
                            <TextArea
                                defaultValue={caseDetails?.reason}
                                value={caseDetails?.reason}
                                className="!bg-transparent rounded-5"
                                placeholder='Write Remarks'
                            />
                        </Form.Item>
                    </div>
                )}
                <div className='custom-user-input'>
                    <Form.Item className='custom-input mb-0' name="state"
                        colon={false}
                        label="Case State"
                    >
                        <SelectInput
                            showSearch={false}
                            allowClear={false}
                            label={false}
                            fieldName="Wallet Code"
                            defaultValue={caseDetails?.state}
                            value={caseDetails?.state}
                            options={caseStateLu}
                            optionLabel="code"
                            optionValue="code"
                            onChange={handleChange}
                            customClass="!pt-0 !rounded-5"
                        />
                    </Form.Item>
                </div>
            </div>
        </div>

    );
};

export default Details;
